var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSpaces = function SvgSpaces(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14.85V37.7145C0.5 39.1502 2.21425 39.8929 3.26166 38.9109L11.1047 31.5581C11.3158 31.3602 11.5944 31.25 11.8838 31.25H26.125C34.6164 31.25 41.5 24.3664 41.5 15.875C41.5 7.38362 34.6164 0.5 26.125 0.5H14.85C6.92471 0.5 0.5 6.92471 0.5 14.85Z",
    fill: "#8B5CF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14.85V37.7145C0.5 39.1502 2.21425 39.8929 3.26166 38.9109L11.1047 31.5581C11.3158 31.3602 11.5944 31.25 11.8838 31.25H26.125C34.6164 31.25 41.5 24.3664 41.5 15.875C41.5 7.38362 34.6164 0.5 26.125 0.5H14.85C6.92471 0.5 0.5 6.92471 0.5 14.85Z",
    fill: "url(#paint0_linear_13878_66774)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13878_66774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9805 13.6191V18.5391",
    stroke: "white",
    strokeWidth: 3.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.541 7.05859V25.0986",
    stroke: "white",
    strokeWidth: 3.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0996 10.3379L25.0996 21.8179",
    stroke: "white",
    strokeWidth: 3.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6602 13.6191L31.6602 18.5391",
    stroke: "white",
    strokeWidth: 3.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13878_66774",
    x1: 0.500001,
    y1: 41.5,
    x2: 43.42,
    y2: 39.3805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#EA4EE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B5CF6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13878_66774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.08,
    height: 36.08,
    fill: "white",
    transform: "translate(2.96094 0.5)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSpaces);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";